import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import Link from 'components/Link';
import { IconButton, Button } from 'components/buttons';
import { Loader } from 'components/styledComponents';
import ProfilePicture from 'components/ProfilePicture';
import LanguageSelector from './LanguageSelector';
import { useTranslation } from 'hooks';
import { useLocation } from 'react-router-dom';
import {
  DetailsContainer,
  DetailsWrapper,
  Name,
  ProfileImage,
  UserDetails,
  UserInfo
} from './style';
import { joinPath } from 'utils/path';

function PersonalDetails({
  editPath,
  className,
  fullName,
  loading,
  readonly = false,
  user,
  networkStatus,
  onMarkComplete,
  language,
  spinnerSize = '40'
}) {
  const { t, tr } = useTranslation();
  const location = useLocation();

  const handleClick = useCallback(() => {
    onMarkComplete && onMarkComplete({ markComplete: true });
  }, [onMarkComplete]);

  const path = useMemo(() => {
    return editPath ? joinPath(editPath, 'pdfcreation') : '';
  }, [editPath]);

  return (
    <Loader className={className} component={UserInfo} loading={loading} spinnerSize={spinnerSize}>
      <Container>
        <LanguageSelector />
        <DetailsWrapper>
          <DetailsContainer>
            <ProfileImage
              alt={t('placeholder.profileImage')}
              as={ProfilePicture}
              size="large"
              src={user?.photo}
            />
            <UserDetails>
              <Name>{fullName || t('title.fullName')}</Name>
              {!readonly && <IconButton component={Link} icon="Edit" to="/account" />}

              {/* <div className="submitAppButton">
                {networkStatus && networkStatus === 200 && (
                  <>
                    <Button
                      color="primary"
                      disabled={false}
                      label={t('button.submitApplication')}
                      onClick={handleClick}
                    />
                    <div style={{ paddingTop: '10px' }}></div>
                  </>
                )}

                <Button
                  component={Link}
                  color="primary"
                  style={{ color: 'white' }}
                  disabled={false}
                  label={t('button.createCV')}
                  to={path}
                  state={{ background: location }}
                />
              </div> */}
            </UserDetails>
          </DetailsContainer>
        </DetailsWrapper>
      </Container>
    </Loader>
  );
}

PersonalDetails.propTypes = {
  className: PropTypes.string,
  fullName: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  readonly: PropTypes.bool,
  user: PropTypes.object,
  spinnerSize: PropTypes.string
};

export default PersonalDetails;
